import { ToolkitStudyV1Request, isNumber } from '@aloft/toolkit-shared';

import { getAnalysisFeatureUnitString } from './getAnalysisFeatureUnitString.ts';

export const createStudyResultString = (
  analysisFeature: ToolkitStudyV1Request['analysisFeature'],
  reconciledValue: ToolkitStudyV1Request['body']['reconciledValue'],
  separator = '/',
): string => {
  const unit = getAnalysisFeatureUnitString(analysisFeature);

  let prefix: string;

  const isPercent = isNumber(reconciledValue);
  if (isPercent) {
    prefix = `${reconciledValue.toLocaleString()}%`;
  } else {
    const isDollarsOnly = reconciledValue.unitAmount % 100 === 0;
    prefix = reconciledValue.toString(isDollarsOnly);
  }

  return `${prefix} ${separator} ${unit}`;
};
